import styled from 'styled-components';

export const FormContainer = styled.div`
  @media only screen and (max-device-width: 640px) {
    margin-top: 15px;
  }
`;
